/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_SubscribeInputs */

const en_read_along_subscribe = /** @type {(inputs: Read_Along_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const es_read_along_subscribe = /** @type {(inputs: Read_Along_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Read_Along_SubscribeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_subscribe = /** @type {((inputs?: Read_Along_SubscribeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_SubscribeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_subscribe(inputs)
	return en_read_along_subscribe(inputs)
});